export default __webpack_public_path__ + "static/media/tommyXTimberlandLogo.b953930c.svg";